var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon263(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_1095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.1131C6.912 16.1131 5.872 15.9051 4.88 15.4891C3.93067 15.0838 3.08533 14.5104 2.344 13.7691C1.60267 13.0278 1.02933 12.1824 0.624 11.2331C0.208 10.2411 0 9.20111 0 8.11311C0 7.02511 0.208 5.98511 0.624 4.99311C1.02933 4.04378 1.60267 3.19845 2.344 2.45711C3.08533 1.71578 3.93067 1.14245 4.88 0.737113C5.872 0.321113 6.912 0.113113 8 0.113113C9.088 0.113113 10.128 0.321113 11.12 0.737113C12.0693 1.14245 12.9147 1.71578 13.656 2.45711C14.3973 3.19845 14.9707 4.04378 15.376 4.99311C15.792 5.98511 16 7.02511 16 8.11311C16 9.20111 15.792 10.2411 15.376 11.2331C14.9707 12.1824 14.3973 13.0278 13.656 13.7691C12.9147 14.5104 12.0693 15.0838 11.12 15.4891C10.128 15.9051 9.088 16.1131 8 16.1131ZM8 14.5131C9.16267 14.5131 10.24 14.2198 11.232 13.6331C12.192 13.0678 12.9547 12.3051 13.52 11.3451C14.1067 10.3531 14.4 9.27578 14.4 8.11311C14.4 6.95045 14.1067 5.87311 13.52 4.88111C12.9547 3.92111 12.192 3.15845 11.232 2.59311C10.24 2.00645 9.16267 1.71311 8 1.71311C6.83733 1.71311 5.76 2.00645 4.768 2.59311C3.808 3.15845 3.04533 3.92111 2.48 4.88111C1.89333 5.87311 1.6 6.95045 1.6 8.11311C1.6 9.27578 1.89333 10.3531 2.48 11.3451C3.04533 12.3051 3.808 13.0678 4.768 13.6331C5.76 14.2198 6.83733 14.5131 8 14.5131ZM7.2 4.11311H8.8V5.71311H7.2V4.11311ZM7.2 7.31311H8.8V12.1131H7.2V7.31311Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_1095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon263);
export default __webpack_public_path__ + "static/media/Icon-263.52bf37cb542706db2b76dee9d3cf97a6.svg";
export { ForwardRef as ReactComponent };